import { v4 as uuidv4 } from 'uuid';

export const onLoadInAuth = () => () => {
  const uuid = uuidv4();
  if (window.inauthSetTid) {
    window.inauthSetTid(uuid, 'GAC');
    window.sessionStorage.setItem('inauth_transaction_identifier', uuid);
  }
};
